import React from "react";
import ReactDOM from "react-dom";
import App from "./views/Dashboard.js";

import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";

ReactDOM.render(<App />, document.getElementById("root"));
